import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dashboard_web_push",
  "use": "dashboard_web_push-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"dashboard_web_push\"><path clip-rule=\"evenodd\" d=\"M18.667 30.009h-8.89l.89-3.413h7.11l.89 3.413v0zM27.378.889H17.6a3.556 3.556 0 00-3.556 3.555v5.334a3.556 3.556 0 003.556 3.555h4.444v4.445l4.445-4.445h.889a3.556 3.556 0 003.555-3.555V4.444A3.556 3.556 0 0027.378.89z\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M18.044 6.667a.444.444 0 100 .889.444.444 0 000-.89M22.489 6.667a.444.444 0 100 .889.444.444 0 000-.89M26.933 6.667a.444.444 0 100 .889.444.444 0 000-.89M7.111 30.009h14.222M.889 23.182h26.667M27.556 17.991v5.191c0 1.885-1.592 3.414-3.556 3.414H4.444c-1.963 0-3.555-1.529-3.555-3.414V11.236c0-1.886 1.592-3.414 3.555-3.414h6.223\" stroke=\"currentColor\" stroke-width=\"1.75\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/dashboard_web_push.svg
// module id = 2ZYg
// module chunks = 39 44